// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// submenu
	let itemsMenu = document.querySelectorAll(
		'.privary-navigation .privary-navigation__item',
	)
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			const event = ['mouseenter', 'mouseleave']
			event.forEach((event) => {
				itemMenu.addEventListener(event, () => {
					itemMenu.classList.toggle('hover')
					itemMenu.querySelector('.submenu').classList.toggle('show')
				})
			})
		}
	})

	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll(
			'.burger-menu__mainnav ul li:has(.submenu)',
		)
		let prevMenuItem

		menu_Items.forEach((element) => {
			// active for link generate in js
			let Main_Link = element.querySelector('a')
			let Link_url = Main_Link.href
			let Element_wrap = element.querySelector('.submenu')
			const newListItem = `
				<li class="privary-navigation__item primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">Overview</a>
				</li>`

			//Element_wrap.insertAdjacentHTML('afterbegin', newListItem)

			// active for link generate in js
			if (Main_Link.classList.contains('active')) {
				Main_Link.nextElementSibling.querySelector('a').classList.add('active')
			}

			if (
				[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
					item.classList.contains('active'),
				)
			) {
				Main_Link.nextElementSibling.classList.add('active')
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault()
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
					prevMenuItem.classList.remove('active')
				e.target.nextElementSibling.classList.toggle('active')
				prevMenuItem = e.target.nextElementSibling
			})
		})
	}

	// Burger Menu Funcionality Open and Close Menu
	const btn_Menu = document.querySelectorAll('[data-ctaburger]')
	const menu_Section = document.querySelector('[data-menuburger]')
	btn_Menu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			menu_Section.classList.toggle('open')
			document.querySelector('body').classList.toggle('no-scroll')
		})
	})
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(
		'.email-signup .input input',
	)
	if (allInputsSignUp) {
		allInputsSignUp.forEach((input) => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved')
			})
		})
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field')

		for (let j = 0; j < allffields.length; j++) {
			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'checkbox' &&
					allffields[j].getElementsByTagName('input')[0].type.toLowerCase() !=
						'radio'
				) {
					allffields[j]
						.getElementsByTagName('input')[0]
						.addEventListener('focus', function () {
							this.parentElement.classList.add('moved')
						})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j]
					.getElementsByTagName('select')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j]
					.getElementsByTagName('textarea')[0]
					.addEventListener('focus', function () {
						this.parentElement.classList.add('moved')
					})
			}
		}
	}
	
	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll] , .scroll')
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				if(section_to_scroll.href.includes("section#")|| section_to_scroll.href.includes("#form_id")){
					let section_to_scroll_id = section_to_scroll.hash.split('#')[1];
					console.log(section_to_scroll_id);
					animateTo(`#${section_to_scroll_id}`);
				}else{
					animateTo(section_to_scroll.hash)
				}
			})
		})
	}

	//cta goto to form
	const ctas_form = document.querySelectorAll('a')
	if (ctas_form) {
		ctas_form.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				const section_to_scroll = new URL(e.target.href)
				if (section_to_scroll.href.includes("#form_id")) {
					e.preventDefault()
					let section_to_scroll_id = section_to_scroll.hash.split('#')[1]
					console.log(section_to_scroll_id)
					animateTo(`#${section_to_scroll_id}`)
				}
			})
		})
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll('[data-accodion] .tab-js')
	normal_accordion.forEach((item, i) => {
		item.addEventListener('click', (element) => {
			element.target.classList.toggle('active')
			element.target.nextElementSibling.classList.toggle('active')
		})

		if (i == 0) item.click()
	})

	// table section
	const tablesResp = document.querySelectorAll('.capacity-chart table')
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			let tableresponsive = document.createElement('div')
			tableresponsive.classList.add('tableHold')
			tablei.parentNode.insertBefore(tableresponsive, tablei)
			tableresponsive.append(tablei)
			const ths = tablei.querySelectorAll('tr:first-child > *')
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td')
				let i = 0
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent)
				}
			})
			const rowHeads = tablei.querySelectorAll('tr td:first-child')
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active')
				})
			})
		})
	}

const twoSliders = document.querySelectorAll('.two-sliders');

twoSliders.forEach((slider) => {
    const sliderCta = slider.querySelectorAll('[data-slidercta]');
    const items = slider.querySelectorAll('.two-sliders__item');

    if (!sliderCta.length || !items.length) return;

    sliderCta.forEach((cta) => {
        cta.addEventListener('click', (e) => {
            e.preventDefault();
            const activeIndex = Array.from(items).findIndex(item => 
                item.classList.contains('active')
            );
            const direction = cta.getAttribute('data-slidercta');
            
            let newIndex;
            if (direction === 'right') {
                newIndex = (activeIndex + 1) % items.length;
            } else if (direction === 'left') {
                newIndex = (activeIndex - 1 + items.length) % items.length;
            }

            items.forEach((item) => {
                item.classList.remove('active');
            });

            items[newIndex].classList.add('active');
        });
    });
});

})()


function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop

	if (st > 80) {
		if (st > lastScrollTop) {
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up', 'down')
		}
	}

	lastScrollTop = st <= 0 ? 0 : st
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.querySelector(target)).top - 50
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300
	var start = new Date().getTime()
	console.log(gotoTarget);

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft,
	}
}

//class for scroll
let classtoscroll = document.querySelectorAll('.scroll-js , .btn-scroll')
if (classtoscroll) {
	classtoscroll.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
			let sectiongoto = e.target.hash.split('#')[1]
			animateTo(sectiongoto)
			if (
				document.querySelector('.sub-menu__hold').classList.contains('open')
			) {
				document.querySelector('.sub-menu__hold').classList.remove('open')
			}
		})
	})
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold')
let allsublinks = document.querySelectorAll('.sub-menu a')
if (allsublinks.length > 1) {
	allsublinks.forEach((ele) => {
		ele.addEventListener('click', function (ev) {
			if (ele.classList.contains('active')) {
				ev.preventDefault()
			}
		})
	})
	let toggleBtn = document.querySelector('.sub-menu__toggle')
	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open')
		})
	}
} else if (submenuHold.length > 0) {
	submenuHold[0].classList.add('hidden')
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('.burger-menu')
	const isMenuVisible = menu && menu.classList.contains('open')
	const elements = document.querySelectorAll(
		'.burger-menu .burger-menu__mainnav a, .burger-menu .social-media a',
	)

	elements.forEach((element) => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1')
	})
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex()

	document.addEventListener('focusin', updateMenuTabIndex)
	const menu = document.querySelector('.burger-menu')
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex)
	}
})
